
<div
  [ngClass]="footerContainerCSSClasses"
  class="d-flex align-items-stretch justify-content-between container"
  
>
  <div class="row" style="width:100%;">
    <div class="col-md-12 col-sm-12 ">
      <div><span class="text-dark-75"  *ngIf="false">Powered by</span></div>
      <div><span class="font-weight-bolder text-dark-75"><a href="{{powered_link}}" class="text-dark-75" >Todos los Derechos Reservado © {{ currentYear }}</a></span></div>
    </div>

    <div class="col-md-12 col-sm-5">
      <div class="text-dark order-2 order-md-1  text-right" *ngIf="false">
        <span class="text-dark-75 font-weight-bold mr-2" >Regulado y supervisado por la Superintendencia de Seguros y Reaseguros de Panamá</span>
      </div>
    </div>

    <div class="col-md-2 col-sm-6  text-right" *ngIf="false">
      <img src="/assets/media/logos/logo-super-intendecia.png" width="80"  />
    </div>
  </div>
</div>